export const FRONTEND_ALERT_ERROR = 'FRONTEND_ALERT_ERROR';
export const WRONG_ADDRESS = 'Votre adresse est incorrecte ou incomplète';
export const UNAVAILABLE_ADDRESS = 'Désolé, nous ne livrons pas dans cette zone actuellement.';
